import { render, staticRenderFns } from "./Wizard.global.vue?vue&type=template&id=23b3da3c&scoped=true&lang=pug&"
import script from "./Wizard.global.vue?vue&type=script&lang=ts&"
export * from "./Wizard.global.vue?vue&type=script&lang=ts&"
import style0 from "./Wizard.global.vue?vue&type=style&index=0&id=23b3da3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3da3c",
  null
  
)

export default component.exports